import { render } from "./FnRowDetail.vue?vue&type=template&id=9b23890c"
import script from "./FnRowDetail.vue?vue&type=script&lang=js"
export * from "./FnRowDetail.vue?vue&type=script&lang=js"

import exportComponent from "e:\\AiGreate\\tmp\\vertex\\webui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__